import { render } from "./AIMLItsHowWorkComp.vue?vue&type=template&id=74520a8a&scoped=true"
import script from "./AIMLItsHowWorkComp.vue?vue&type=script&lang=js"
export * from "./AIMLItsHowWorkComp.vue?vue&type=script&lang=js"

import "./AIMLItsHowWorkComp.vue?vue&type=style&index=0&id=74520a8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74520a8a"]])

export default __exports__